<script lang="ts">
	import CrypticLogo from './components/icons/Cryptic.svelte'
	import Aesthetic from './components/Aesthetic.svelte'
	import Flames from './components/Flames.svelte'
	import Plan from './components/Plan.svelte'
	import Misc from './components/Misc.svelte'
	import { initStore } from './utils/store'

	initStore()
</script>

<style>
	.dumb {
		max-width: 30rem;
		margin: 0 auto;
		padding: 0 1rem;
	}
	.dumb > * {
		margin: 2rem 0;
	}
	.logo {
		--header-size: 5rem;
		max-width: var(--header-size);
		min-width: var(--header-size);
		max-height: var(--header-size);
		min-height: var(--header-size);
		margin-right: 1rem;
	}
	.header {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.title {
		font-family: 'Press Start 2P';
		width: 15rem;
		line-height: 1.6rem;
	}
	.intro {
		margin-top: 2rem;
	}
</style>

<div class="dumb">
	<div class="header">
		<div class="logo"><CrypticLogo /></div>
		<h2 class="title">Cryptic Dumbathon 2022</h2>
	</div>
	<div class="intro">
		<p>dumbathon is <Flames>eternal</Flames></p>
		<p>remember this next time you question whether or not the dumbathon will happen</p>
		<Aesthetic />
	</div>
	<div class="plan">
		<Plan />
	</div>
	<div class="misc">
		<Misc />
	</div>
</div>